
import { wasmModule } from "../wasm/wasmModule"
import { getAccessToken } from "../../../utils/utils"
import store from "@/core/app/store"
const { VITE_WEBSOCKET_URL } = import.meta.env

const HEARTBEAT_TIMEOUT = 15000 // 15 秒没消息算超时
const RECONNECT_DELAY = 2000
class SagemakerModule {
  initCallback() {
    ;(window as any).featureGetDataCallback =
      this.featureGetDataCallback.bind(this)
    ;(window as any).featureSetUpEndCallback =
      this.featureSetUpEndCallback.bind(this)
  }

  featureGetDataCallback(type, data) {
    console.log("Feature: data =", data)
    this.cloudAIRequest(
      data.tooth_type,
      data,
    )
  }

  featureSetUpEndCallback() {
    wasmModule.moduleManager.FreeRelabelModuleAfterFeature()
    if (wasmModule.stageShowTypeNormalCallback) {
      wasmModule.stageShowTypeNormalCallback()
    }
  }
 
  cloudAIRequest(type, input) {
    const featureModule = wasmModule.moduleManager.GetModuleToothFeature()
    const urlStr = window.location.href.toString()
    const orgId = store.getState().userService.user.current_orgId

    const patientId = urlStr.slice(
      urlStr.indexOf("patient") + 8,
      urlStr.indexOf("case") - 1,
    )
    const caseId = urlStr.slice(
      urlStr.indexOf("case") + 5,
      urlStr.indexOf("treat") - 1,
    )

    let socket: WebSocket | null = null
    let heartbeatTimer: number | null = null
    let isAlive = false   // 是否“收到过任何事件”

    /** 启动/重置心跳（连接阶段也算） */
    const startHeartbeat = () => {
      stopHeartbeat()

      heartbeatTimer = window.setTimeout(() => {
        console.error("feature WebSocket 心跳超时（含连接阶段）")
        socket?.close()
      }, HEARTBEAT_TIMEOUT)
    }

    /** 停止心跳 */
    const stopHeartbeat = () => {
      if (heartbeatTimer) {
        clearTimeout(heartbeatTimer)
        heartbeatTimer = null
      }
    }

    /** 标记活跃并续命 */
    const markAlive = () => {
      isAlive = true
      startHeartbeat()
    }

    /** 建立连接 */
    const connectSocket = () => {
      isAlive = false

      socket = new WebSocket(
        `${VITE_WEBSOCKET_URL}/patient-mgmt/v1/org/${orgId}/patients/${patientId}/txplans/${caseId}/ai-clinical-presetup`,
        getAccessToken(),
      )

      // 创建 socket 立刻开始心跳
      startHeartbeat()

      socket.onopen = () => {
        markAlive()

        socket!.send(
          JSON.stringify({
            type: "inference",
            body: {
              case_id: 0,
              token: "0",
              algorithm: input.algorithm,
              input: input.input,
            },
          }),
        )
      }

      socket.onmessage = (msg) => {
        markAlive()
        const aiRqRes = JSON.parse(msg.data)
        switch (aiRqRes.type) {
          case "keep_alive":
            break

          case "response_inference":
            if (aiRqRes.body.result === 1) {
              socket?.close()
              featureModule.DealMsg(
                JSON.stringify(aiRqRes.body.output),
              )
            }
            break
        }
      }

      socket.onerror = () => {
        socket?.close()
      }

      socket.onclose = () => {
        stopHeartbeat()

        // ❗ 如果在心跳时间内从未成功过，认为连接失败
        if (!isAlive) {
          console.warn("WebSocket 连接失败或卡死，尝试重连")
          setTimeout(connectSocket, RECONNECT_DELAY)
        }
      }
    }

    connectSocket()
  }
}
export const sagemakerModule = new SagemakerModule()
